import { render, staticRenderFns } from "./aboutLink.vue?vue&type=template&id=d5b35ce8&scoped=true&"
import script from "./aboutLink.vue?vue&type=script&lang=js&"
export * from "./aboutLink.vue?vue&type=script&lang=js&"
import style0 from "./aboutLink.vue?vue&type=style&index=0&id=d5b35ce8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b35ce8",
  null
  
)

export default component.exports